import { theme } from '$theme';
import styled from '@emotion/styled';

export const StyledPdpCoreBottomSpace = styled.div({
    marginBottom: theme.space[4],
});
